import { VOExhibition, VOMedia } from "../model/DataStructure.js";
import { Background } from "./Background.js";
import { Icon } from "./Icon.js";
import { Selector, SelectorItemData } from "./Selector.js";

export interface DetailOptions {
    container: HTMLElement;
    assetsUrl: string;
    visible: boolean;
    onSelectMedia: (item: VOMedia) => void;
}

export class Detail {
    private _element: HTMLDivElement;
    private _options: DetailOptions;
    private _selector: Selector<VOMedia>;
    private _background: Background;

    constructor(options: DetailOptions) {
        options = e5.object.merge({
            visible: false
        }, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "detail base__panel base__panel--hidden";
        this._element.innerHTML = `
        <div class="detail__background"></div>
        <div class="detail__background-gradient"></div>
        <div class="detail__header">
            <div class="detail__title-container">
                <div class="detail__title"></div>
            </div>
        </div>
        <div class="detail__body">
            <div class="detail__scroll-wrapper">
                <div class="detail__description"></div>
            </div>
        </div>
        <div class="detail__footer"></div>
        `;

        this._background = new Background({
            container: this._element.querySelector(".detail__background")
        });

        this._selector = new Selector({
            container: this._element.querySelector(".detail__footer"),
            layout: "singleline",
            showIndicator: false,
            onSelect: options.onSelectMedia
        });

        this.visible = options.visible;

        options.container.appendChild(this._element);
    }

    public load(e: VOExhibition): void {
        this._background.load(e);

        this._element.querySelector(".detail__scroll-wrapper")
            .scrollTop = 0;

        let title = e.name;
        if (e.subline) {
            title += " - " + e.subline;        }

        this._element.querySelector(".detail__title")
            .textContent = title;

        this._element.querySelector(".detail__description")
            .textContent = e.description || "";


        const items: SelectorItemData<VOMedia>[] = [];

        for (let m of e.medias) {
            items.push({
                name: m.name,
                previewImage: m.preview_image_url,
                data: m,
                icon: m.icon
            });
        }
        this._selector.load(items);
    }

    public get visible(): boolean {
        return !this._element.classList.contains("base__panel--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("base__panel--hidden", !value);
    }
}